import { observer } from 'mobx-react';

import { useSnappyGiftWidgetData } from '../../hooks/useSnappyGiftWidgetData';
import type { SnappyGiftWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

interface SnappyGiftWidgetProps {
  sizeType: WidgetSizeType;
  data: SnappyGiftWidgetDataType;
}

function SnappyGiftWidgetComponent(props: SnappyGiftWidgetProps) {
  const { data, sizeType } = props;
  const { widgetImageUrl, handleClick } = useSnappyGiftWidgetData({ event: data.event });

  return (
    <WidgetWrapper dataTestId="snappy-gift-widget" sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const SnappyGiftWidget = observer(SnappyGiftWidgetComponent);
